import React from "react";
import { ArrowLeft } from "lucide-react";

const MobileDateModal = ({ isOpen, onClose, title, subTitle, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex flex-col justify-end">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-navy/80 backdrop-blur-sm animate-in fade-in duration-300" 
        onClick={onClose} 
      />

      {/* Bottom Sheet */}
      <div className="relative bg-white w-full h-[90vh] rounded-t-[32px] shadow-premium flex flex-col overflow-hidden animate-in slide-in-from-bottom duration-500 ease-out">
        {/* Drag Handle */}
        <div className="w-12 h-1.5 bg-navy/10 rounded-full mx-auto mt-3 mb-1 shrink-0" />

        {/* Header */}
        <div className="flex items-center px-6 py-4 border-b border-navy/5 shrink-0">
          <button onClick={onClose} className="p-2 -ml-2 text-gold active:scale-95 transition-transform">
            <ArrowLeft className="w-6 h-6" />
          </button>
          <div className="flex-1 text-center">
            <h3 className="text-lg font-heading font-bold text-navy uppercase tracking-tight">
              {title} {/* Dynamically render the title */}
            </h3>
            <div className="text-[10px] font-extrabold text-gold uppercase tracking-[0.2em]">
              {subTitle} {/* Dynamically render the subtitle */}
            </div>
          </div>
          <div className="w-10" />
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-4 custom-scrollbar">
          {children}
        </div>

        {/* Fixed Footer */}
        <div className="p-6 border-t border-gold/20 bg-white shrink-0">
          <button 
            onClick={onClose} 
            className="w-full py-4 bg-navy text-white rounded-2xl font-heading font-bold uppercase tracking-widest shadow-xl shadow-navy/20 active:scale-[0.98] transition-transform"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileDateModal;